import React from 'react';
import mapaBrasil from '../assets/images/maps/mapa_brasil.png';

function MapaBrasil() {
  return <img alt="Mapa do Brasil" src={mapaBrasil} />;
}

export default MapaBrasil;
